var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAttachmentPpt = function SvgAttachmentPpt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E7E9EC",
    fillRule: "evenodd",
    d: "M12 7.5A1.5 1.5 0 0 0 10.5 9v8.25h3V7.5H12Zm1.5 23.25h-3v9.75A1.5 1.5 0 0 0 12 42h24a1.5 1.5 0 0 0 1.5-1.5v-.75H15a1.5 1.5 0 0 1-1.492-1.347l-.008-.153v-7.5Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#888D96",
    d: "M13.5 30.75h.75v7.5c0 .414.336.75.75.75h24a.75.75 0 0 0 .75-.75V14.155l-.244-.28H33V6.393L32.658 6H15a.75.75 0 0 0-.75.75v10.5h-.75V6.75a1.5 1.5 0 0 1 1.5-1.5h18l7.5 8.625V38.25a1.5 1.5 0 0 1-1.347 1.492L39 39.75H15a1.5 1.5 0 0 1-1.492-1.347l-.008-.153v-7.5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#F3F5F6",
    fillRule: "evenodd",
    d: "M31.13 30.75V18.375c0-.621-.504-1.125-1.125-1.125H14.25V6.75A.75.75 0 0 1 15 6h17.658l.342.393v7.482h6.506l.244.28V38.25A.75.75 0 0 1 39 39H15a.75.75 0 0 1-.75-.75v-6h15.38a1.5 1.5 0 0 0 1.5-1.5Z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#B7BBC2",
    fillRule: "evenodd",
    d: "M14.25 30.751h15.755c.62 0 1.123-.501 1.125-1.121v1.121a1.5 1.5 0 0 1-1.5 1.5H14.25v-1.5Z",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#ED6C47",
    fillRule: "evenodd",
    d: "M9.005 30.75h21c.62 0 1.123-.505 1.125-1.125v-11.25c0-.621-.504-1.125-1.125-1.125H9.005c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125Zm13.393-9.28v-.958h5.071v.958h-1.96v5.405h-1.142V21.47h-1.969Zm-5.273-.958v6.363h1.142v-2.153h1.23c1.468 0 2.255-.884 2.26-2.1-.005-1.223-.783-2.11-2.242-2.11h-2.39Zm1.142 3.27h1.073c.86-.005 1.248-.488 1.248-1.16 0-.682-.387-1.152-1.248-1.152h-1.073v2.311Zm-6.697 3.093v-6.363h2.39c1.46 0 2.237.887 2.242 2.11-.005 1.216-.791 2.1-2.259 2.1h-1.23v2.153H11.57Zm2.215-3.094h-1.072V21.47h1.072c.861 0 1.248.47 1.248 1.151 0 .673-.387 1.156-1.248 1.16Z",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M22.398 20.512v.958h1.969v5.405h1.142V21.47h1.96v-.958H22.4Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M17.125 26.875v-6.363h2.39c1.46 0 2.237.887 2.241 2.11-.004 1.216-.79 2.1-2.258 2.1h-1.23v2.153h-1.143Zm3.463-4.254c0 .673-.387 1.156-1.248 1.16h-1.073V21.47h1.073c.86 0 1.248.47 1.248 1.151ZM11.57 26.875v-6.363h2.39c1.46 0 2.237.887 2.242 2.11-.005 1.216-.791 2.1-2.259 2.1h-1.23v2.153H11.57Zm3.463-4.254c0 .673-.387 1.156-1.248 1.16h-1.072V21.47h1.072c.861 0 1.248.47 1.248 1.151Z",
    clipRule: "evenodd"
  })));
};
export default SvgAttachmentPpt;